const languageTemplate = (resource, languages) => {
    let template = '';
    let i;

    for (i = 0; i < languages.length; i += 1) {
        template += `
        <li>
            <div class="vtc-resource-link sl_norewrite vtc-action"
            id="${resource.ID}"
            type="${resource.type}"
            data-id="${resource.ID}"
            data-number="${resource.number}"
            data-title="${resource.title}"
            data-language="${languages[i]}"
            >
            <label class="vtc-action" for="${resource.ID}-${languages[i]}">
                    <input
                        id="${resource.ID}-${languages[i]}"
                        name="${resource.title}"
                        type="checkbox"
                        class="vtc-resource-selected vtc-action">
                    ${languages[i]}
            </label>
            </div>
        </li>`;
    }
    return template;
};

export default languageTemplate;
